import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/utils/utils";

/**
 * PRODA Badge Component
 *
 * Styled badges matching PRODA brand guidelines with pill shape
 */
const badgeVariants = cva(
    "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
    {
        variants: {
            variant: {
                default: "bg-primary text-primary-foreground",
                secondary: "bg-secondary text-secondary-foreground",
                destructive: "bg-proda-error/10 text-proda-error",
                outline: "text-foreground bg-muted",
                success: "bg-proda-success/10 text-proda-success",
                warning: "bg-proda-warning/10 text-proda-orange",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    },
);

export interface TBadgeProps
    extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: TBadgeProps) {
    return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
